import { IonImg, IonLabel } from '@ionic/react';

import TransitionBg from '@/assets/imgs/transition-bg.svg';
import TransitionLine from '@/assets/imgs/transition-line.svg';

import styles from './Transition.module.scss';

export default function Transition() {
  return (
    <div className={styles.transitionModalContainer}>
      <IonLabel className={styles.modalTitle}>Unos segundos y casi estamos</IonLabel>
      <div className={styles.transitionImgWrapper}>
        <IonImg src={TransitionLine} className={styles.transitionImageLine} />
        <IonImg src={TransitionBg} className={styles.transitionImageBackground} />
      </div>
    </div>
  );
}
